import api from './api'

export default {
  fetchData (id, params) {
    return api.post('/station-data/' + id, params)
  },
  exportData (id, params) {
    return api.post('/station-export/' + id, params)
  },
  fetchDeviceParameters () {
    return api.get('/parameters')
  },
  fetchDevices (stationId) {
    return api.get('/devices/by-station/' + stationId)
  },
  fetchMetrics () {
    return api.get('/metrics')
  },
  fetchDeviceParametersByStation (id) {
    return api.get('/parameters-by-station/' + id)
  }
}
